import { render, staticRenderFns } from "./holdReleaseSalary.vue?vue&type=template&id=2d4c932c&scoped=true"
import script from "./holdReleaseSalary.vue?vue&type=script&lang=js"
export * from "./holdReleaseSalary.vue?vue&type=script&lang=js"
import style0 from "./holdReleaseSalary.vue?vue&type=style&index=0&id=2d4c932c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c932c",
  null
  
)

export default component.exports